/* Bramble & Bolt — premium enhancements.
   Progressive: every form still posts normally to /cart/add without JS. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header shadow on scroll ---------- */
  var header = document.querySelector('.bb-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Reveal on scroll ---------- */
  var reveals = document.querySelectorAll('[data-reveal]');
  if (reveals.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-revealed'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---------- Carousel progress ---------- */
  document.querySelectorAll('.bb-carousel').forEach(function (carousel) {
    var track = carousel.querySelector('.bb-carousel__track');
    var bar = carousel.parentNode.querySelector('.bb-carousel__progress span');
    if (!track || !bar) return;
    var update = function () {
      var max = track.scrollWidth - track.clientWidth;
      var ratio = track.clientWidth / track.scrollWidth;
      bar.style.width = Math.max(ratio * 100, 8) + '%';
      var shown = Math.max(ratio, 0.08);
      var progress = max > 0 ? track.scrollLeft / max : 0;
      bar.style.transform = 'translateX(' + (progress * (1 / shown - 1) * 100) + '%)';
      carousel.parentNode.querySelector('.bb-carousel__progress').hidden = ratio >= 0.99;
    };
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- AJAX add to basket ---------- */
  var DRAWER_SECTION = 'bb-cart-drawer-sec';

  function updateCount(count) {
    document.querySelectorAll('[data-drawer-open="bb-cart-drawer"]').forEach(function (link) {
      var badge = link.querySelector('.bb-cart-count');
      if (!badge && count > 0) {
        badge = document.createElement('span');
        badge.className = 'bb-cart-count';
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      }
      if (badge) {
        badge.textContent = count;
        badge.hidden = count === 0;
        badge.classList.remove('is-bumped');
        void badge.offsetWidth;
        badge.classList.add('is-bumped');
      }
      var label = link.querySelector('.bb-visually-hidden');
      if (label) label.textContent = 'Basket, ' + count + ' item' + (count === 1 ? '' : 's');
    });
  }

  function openCartDrawer() {
    var opener = document.querySelector('[data-drawer-open="bb-cart-drawer"]');
    if (opener) opener.click();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!window.fetch || !window.FormData) return;

    var submitter = event.submitter || form.querySelector('[type="submit"]');
    if (submitter && submitter.name === 'checkout') return;
    event.preventDefault();

    var formData = new FormData(form);
    formData.append('sections', DRAWER_SECTION);
    formData.append('sections_url', window.location.pathname);

    var button = form.querySelector('[data-add-to-cart], .bb-card__quick .bb-btn, [type="submit"]');
    if (button) button.classList.add('is-loading');

    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) {
          var msg = (result.data && (result.data.description || result.data.message)) || 'Sorry, that item could not be added.';
          window.alert(msg);
          return;
        }
        var html = result.data.sections && result.data.sections[DRAWER_SECTION];
        var host = document.getElementById('shopify-section-' + DRAWER_SECTION);
        if (html && host) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('shopify-section-' + DRAWER_SECTION);
          host.innerHTML = fresh ? fresh.innerHTML : html;
        }
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCount(cart.item_count);
            if (button) {
              button.classList.add('is-added');
              setTimeout(function () { button.classList.remove('is-added'); }, 1600);
            }
            openCartDrawer();
          });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  });

  /* ---------- Mobile filter drawer ---------- */
  var facets = document.querySelector('.bb-facets');
  var facetBackdrop = document.querySelector('.bb-facets-backdrop');
  function setFacets(open) {
    if (!facets) return;
    facets.classList.toggle('is-open', open);
    if (facetBackdrop) facetBackdrop.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      var first = facets.querySelector('summary, input, button');
      if (first) first.focus();
    }
  }
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-facets-open]')) { event.preventDefault(); setFacets(true); }
    if (event.target.closest('[data-facets-close]')) { event.preventDefault(); setFacets(false); }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && facets && facets.classList.contains('is-open')) setFacets(false);
  });

  /* ---------- Sticky add to basket (product page, mobile) ---------- */
  var sticky = document.querySelector('.bb-sticky-atc');
  var mainAtc = document.querySelector('[data-add-to-cart]');
  if (sticky && mainAtc && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var below = entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', !entry.isIntersecting && below);
      });
    }).observe(mainAtc);
    var stickyBtn = sticky.querySelector('button');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (mainAtc.disabled) { mainAtc.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' }); return; }
        mainAtc.click();
      });
    }
  }
})();
